<div class="empty-block">
	<div class="ad-space">
		<i class="fa fa-ad"></i>
	</div>
</div>
